import React, { useId } from 'react';

/** The Oasis O — a window onto the market. Colored via currentColor. */
const OasisMark: React.FC<{ className?: string }> = ({ className = 'w-8 h-8 text-accent-400' }) => {
  const id = useId();
  return (
    <svg viewBox="0 0 64 64" className={className} role="img" aria-hidden="true">
      <defs>
        <clipPath id={id}>
          <circle cx="32" cy="32" r="27" />
        </clipPath>
      </defs>
      <circle cx="32" cy="32" r="27" fill="none" stroke="currentColor" strokeWidth="5" />
      <g clipPath={`url(#${id})`}>
        <line x1="0" y1="36" x2="64" y2="36" stroke="currentColor" strokeWidth="4.5" />
        <path d="M 23.5 36 A 8.5 8.5 0 0 1 40.5 36 Z" fill="currentColor" />
      </g>
    </svg>
  );
};

export default OasisMark;
